<div class="color-bar-container" [ngStyle]="{ 'background-color': hexColor() }"></div>
